<template>
  <div class="water-settings">
    <div class="header">
      <h1 class="title">水位</h1>
    </div>
    <validation-observer ref="obs" v-slot="ObserverProps">
      <div class="section">
        <div class="container">
          <h2 class="title">警告水位（cm）</h2>
          <dl class="columns">
            <dt>下限値</dt>
            <dd>
              <ValidationProvider
                rules="linkedRequired:@warnMax"
                immediate
                name="warnMin"
                v-slot="ProviderProps"
              >
                <input
                  type="number"
                  placeholder="下限値"
                  v-model="settings.warnMin"
                />
                <div class="validation-error" v-if="ProviderProps.invalid">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <dl class="columns">
            <dt>上限値</dt>
            <dd>
              <ValidationProvider
                rules="linkedRequired:@warnMin"
                immediate
                name="warnMax"
                v-slot="ProviderProps"
              >
                <input
                  type="number"
                  placeholder="上限値"
                  v-model="settings.warnMax"
                />
                <div class="validation-error" v-if="ProviderProps.invalid">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <h2 class="title">危険水位（cm）</h2>
          <dl class="columns">
            <dt>下限値</dt>
            <dd>
              <ValidationProvider
                rules="linkedRequired:@cautionMax"
                immediate
                name="cautionMin"
                v-slot="ProviderProps"
              >
                <input
                  type="number"
                  placeholder="下限値"
                  v-model="settings.cautionMin"
                />
                <div class="validation-error" v-if="ProviderProps.invalid">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
          <dl class="columns">
            <dt>上限値</dt>
            <dd>
              <ValidationProvider
                rules="linkedRequired:@cautionMin"
                immediate
                name="cautionMax"
                v-slot="ProviderProps"
              >
                <input
                  type="number"
                  placeholder="上限値"
                  v-model="settings.cautionMax"
                />
                <div class="validation-error" v-if="ProviderProps.invalid">
                  {{ ProviderProps.errors[0] }}
                </div>
              </ValidationProvider>
            </dd>
          </dl>
        </div>
      </div>
      <span
        class="btn-submit"
        :class="{ disable: ObserverProps.invalid }"
        @click="update"
        >保存</span
      >
    </validation-observer>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Loader from "@/mixins/loader";

export default {
  mixins: [Loader],

  data() {
    return {
      id: "water",
      settings: {
        warnMin: null,
        warnMax: null,
        cautionMin: null,
        cautionMax: null,
      },
    };
  },

  async mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      await this.show();
    });
  },

  methods: {
    ...mapActions(["retrieveSettings", "updateSettings"]),

    async show() {
      try {
        const ret = await this.retrieveSettings(this.id);
        if (!ret.settings) {
          return;
        }

        if (ret.settings.warn) {
          const vals = ret.settings.warn.split(",");
          this.settings.warnMin = vals[0];
          this.settings.warnMax = vals[1];
        }
        if (ret.settings.caution) {
          const vals = ret.settings.caution.split(",");
          this.settings.cautionMin = vals[0];
          this.settings.cautionMax = vals[1];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async update() {
      const params = {
        id: this.id,
        settings: {
          warn: this.settings.warnMin + "," + this.settings.warnMax,
          caution: this.settings.cautionMin + "," + this.settings.cautionMax,
        },
      };
      try {
        await this.updateSettings(params);
        this.$router.push({ name: "water-show" });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" src="">
.water-settings {
  .header {
    margin: 2rem;
  }
  .section {
    overflow: auto;
    width: 50%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;

      dl.columns {
        width: 100%;
        display: grid;
        grid-template-columns: 170px 1fr;
        align-items: top;
        grid-gap: 0px 0px;
        margin: 0;
        padding: 0;
        font-size: 16px;
        color: #333;
      }

      .columns dt {
        display: block;
        text-align: left;
        width: 100%;
        margin: 0;
        padding: 16px;
      }

      .columns dd {
        display: block;
        width: 100%;
        border-left: solid 1px #ddd;
        margin: 0;
        padding: 16px;

        &.input-with-unit {
          display: flex;
          align-items: center;
          .unit {
            margin-left: 1rem;
            word-break: keep-all;
          }
        }
      }
      .columns dt:nth-of-type(odd) {
        background: #f3f3f3;
      }
      .columns dd:nth-of-type(odd) {
        background: #f3f3f3;
      }

      /* フォーム */

      input[type="text"],
      input[type="date"],
      input[type="number"] {
        width: 100%;
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 16px;
        font-size: 16px;
        outline: none;
      }

      input[type="text"]:focus,
      input[type="date"]:focus,
      input[type="number"]:focus {
        background: var(--purple-tertiary);
      }

      select {
        height: 40px;
        border-radius: 20px;
        border: solid 1px var(--purple);
        padding: 0 38px 0 16px;
        font-size: 16px;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center;
        background-size: 25px 25px;
      }

      select:focus {
        background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
          calc(100% - 10px) center var(--purple-tertiary);
        background-size: 25px 25px;
      }

      textarea {
        font-size: 16px;
        width: 100%;
        min-height: 200px;
        white-space: pre-wrap;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: solid 1px var(--purple);
        padding: 10px;
        border-radius: 10px 10px 0 10px;
      }

      textarea:focus {
        background: var(--purple-tertiary);
      }

      input[type="radio"] {
        display: none;
      }
      input[type="radio"] + label {
        padding: 0 20px 0 0;
      }
      input[type="radio"]:disabled + label {
        color: #aaa;
      }

      input[type="radio"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="radio"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_on.svg") no-repeat center left;
        background-size: 24px 24px;
        display: inline-block;
      }
      input[type="radio"]:disabled + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_radio_disabled.svg") no-repeat
          center left;
        background-size: 24px 24px;
        display: inline-block;
      }

      input[type="checkbox"] {
        display: none;
      }
      input[type="checkbox"] + label {
        padding: 0 20px 0 0;
      }

      input[type="checkbox"] + label:before {
        display: inline-block;
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_off.svg") no-repeat center
          left;
        background-size: 24px 24px;
        padding: 0 16px 0 0;
      }
      input[type="checkbox"]:checked + label:before {
        white-space: pre;
        content: "    ";
        background: url("~@/assets/icons/ic_checkbox_on.svg") no-repeat center
          left;
        background-size: 24px 24px;
        display: inline-block;
      }
    }
  }
  .btn-submit {
    display: block;
    background: var(--purple);
    font-size: 14px;
    text-align: center;
    width: 100px;
    height: 30px;
    border-radius: 15px;
    color: #fff;
    padding: 6px 20px;
    margin: 10px auto 10px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
    }
  }
}
</style>
